module.exports = require("./mas-TZ.d.ts");